module.exports = __webpack_public_path__ + "static/img/11.1844598.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/11.png
// module id = GL4N
// module chunks = 0